import { format, getTime, formatDistanceToNow } from 'date-fns';
import moment from "moment";

// ----------------------------------------------------------------------

export function fDate(date, newFormat) {
  const fm = newFormat || 'dd MMM yyyy';

  return date ? format(new Date(date), fm) : '';
}

export function fDateTime(date, newFormat) {
  const fm = newFormat || 'dd MMM yyyy p';

  return date ? format(new Date(date), fm) : '';
}

export function fTimestamp(date) {
  return date ? getTime(new Date(date)) : '';
}

export function fToNow(date, locale) {
  return date
    ? formatDistanceToNow(new Date(date), {
        addSuffix: true,
        locale: locale || undefined,
      })
    : '';
}

export function formatForFrappe(date) {
    return moment(date).format('YYYY-MM-DD HH:mm:ss.SSSSSSSSS');
}
